import { render, staticRenderFns } from "./WalletDetails.vue?vue&type=template&id=41c510d9&scoped=true"
import script from "./WalletDetails.vue?vue&type=script&lang=js"
export * from "./WalletDetails.vue?vue&type=script&lang=js"
import style0 from "./WalletDetails.vue?vue&type=style&index=0&id=41c510d9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41c510d9",
  null
  
)

/* custom blocks */
import block0 from "./WalletDetails.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports